/**
 * @fileoverview gRPC-Web generated client stub for stories.v1
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v6.33.4
// source: stories/v1/story.proto


/* eslint-disable */
// @ts-nocheck


import * as grpcWeb from 'grpc-web';

import * as google_protobuf_empty_pb from 'google-protobuf/google/protobuf/empty_pb'; // proto import: "google/protobuf/empty.proto"
import * as stories_v1_story_pb from '../../stories/v1/story_pb'; // proto import: "stories/v1/story.proto"


export class StoryServiceClient {
  client_: grpcWeb.AbstractClientBase;
  hostname_: string;
  credentials_: null | { [index: string]: string; };
  options_: null | { [index: string]: any; };

  constructor (hostname: string,
               credentials?: null | { [index: string]: string; },
               options?: null | { [index: string]: any; }) {
    if (!options) options = {};
    if (!credentials) credentials = {};
    options['format'] = 'text';

    this.client_ = new grpcWeb.GrpcWebClientBase(options);
    this.hostname_ = hostname.replace(/\/+$/, '');
    this.credentials_ = credentials;
    this.options_ = options;
  }

  methodDescriptorListStories = new grpcWeb.MethodDescriptor(
    '/stories.v1.StoryService/ListStories',
    grpcWeb.MethodType.UNARY,
    stories_v1_story_pb.ListStoriesRequest,
    stories_v1_story_pb.ListStoriesResponse,
    (request: stories_v1_story_pb.ListStoriesRequest) => {
      return request.serializeBinary();
    },
    stories_v1_story_pb.ListStoriesResponse.deserializeBinary
  );

  listStories(
    request: stories_v1_story_pb.ListStoriesRequest,
    metadata?: grpcWeb.Metadata | null): Promise<stories_v1_story_pb.ListStoriesResponse>;

  listStories(
    request: stories_v1_story_pb.ListStoriesRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: stories_v1_story_pb.ListStoriesResponse) => void): grpcWeb.ClientReadableStream<stories_v1_story_pb.ListStoriesResponse>;

  listStories(
    request: stories_v1_story_pb.ListStoriesRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: stories_v1_story_pb.ListStoriesResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/stories.v1.StoryService/ListStories',
        request,
        metadata || {},
        this.methodDescriptorListStories,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/stories.v1.StoryService/ListStories',
    request,
    metadata || {},
    this.methodDescriptorListStories);
  }

  methodDescriptorGetStory = new grpcWeb.MethodDescriptor(
    '/stories.v1.StoryService/GetStory',
    grpcWeb.MethodType.UNARY,
    stories_v1_story_pb.GetStoryRequest,
    stories_v1_story_pb.Story,
    (request: stories_v1_story_pb.GetStoryRequest) => {
      return request.serializeBinary();
    },
    stories_v1_story_pb.Story.deserializeBinary
  );

  getStory(
    request: stories_v1_story_pb.GetStoryRequest,
    metadata?: grpcWeb.Metadata | null): Promise<stories_v1_story_pb.Story>;

  getStory(
    request: stories_v1_story_pb.GetStoryRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: stories_v1_story_pb.Story) => void): grpcWeb.ClientReadableStream<stories_v1_story_pb.Story>;

  getStory(
    request: stories_v1_story_pb.GetStoryRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: stories_v1_story_pb.Story) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/stories.v1.StoryService/GetStory',
        request,
        metadata || {},
        this.methodDescriptorGetStory,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/stories.v1.StoryService/GetStory',
    request,
    metadata || {},
    this.methodDescriptorGetStory);
  }

  methodDescriptorListStoriesByMonth = new grpcWeb.MethodDescriptor(
    '/stories.v1.StoryService/ListStoriesByMonth',
    grpcWeb.MethodType.UNARY,
    stories_v1_story_pb.ListStoriesByMonthRequest,
    stories_v1_story_pb.ListStoriesByMonthResponse,
    (request: stories_v1_story_pb.ListStoriesByMonthRequest) => {
      return request.serializeBinary();
    },
    stories_v1_story_pb.ListStoriesByMonthResponse.deserializeBinary
  );

  listStoriesByMonth(
    request: stories_v1_story_pb.ListStoriesByMonthRequest,
    metadata?: grpcWeb.Metadata | null): Promise<stories_v1_story_pb.ListStoriesByMonthResponse>;

  listStoriesByMonth(
    request: stories_v1_story_pb.ListStoriesByMonthRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: stories_v1_story_pb.ListStoriesByMonthResponse) => void): grpcWeb.ClientReadableStream<stories_v1_story_pb.ListStoriesByMonthResponse>;

  listStoriesByMonth(
    request: stories_v1_story_pb.ListStoriesByMonthRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: stories_v1_story_pb.ListStoriesByMonthResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/stories.v1.StoryService/ListStoriesByMonth',
        request,
        metadata || {},
        this.methodDescriptorListStoriesByMonth,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/stories.v1.StoryService/ListStoriesByMonth',
    request,
    metadata || {},
    this.methodDescriptorListStoriesByMonth);
  }

  methodDescriptorListMonthlyThemes = new grpcWeb.MethodDescriptor(
    '/stories.v1.StoryService/ListMonthlyThemes',
    grpcWeb.MethodType.UNARY,
    stories_v1_story_pb.ListMonthlyThemesRequest,
    stories_v1_story_pb.ListMonthlyThemesResponse,
    (request: stories_v1_story_pb.ListMonthlyThemesRequest) => {
      return request.serializeBinary();
    },
    stories_v1_story_pb.ListMonthlyThemesResponse.deserializeBinary
  );

  listMonthlyThemes(
    request: stories_v1_story_pb.ListMonthlyThemesRequest,
    metadata?: grpcWeb.Metadata | null): Promise<stories_v1_story_pb.ListMonthlyThemesResponse>;

  listMonthlyThemes(
    request: stories_v1_story_pb.ListMonthlyThemesRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: stories_v1_story_pb.ListMonthlyThemesResponse) => void): grpcWeb.ClientReadableStream<stories_v1_story_pb.ListMonthlyThemesResponse>;

  listMonthlyThemes(
    request: stories_v1_story_pb.ListMonthlyThemesRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: stories_v1_story_pb.ListMonthlyThemesResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/stories.v1.StoryService/ListMonthlyThemes',
        request,
        metadata || {},
        this.methodDescriptorListMonthlyThemes,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/stories.v1.StoryService/ListMonthlyThemes',
    request,
    metadata || {},
    this.methodDescriptorListMonthlyThemes);
  }

  methodDescriptorCreateMonthlyTheme = new grpcWeb.MethodDescriptor(
    '/stories.v1.StoryService/CreateMonthlyTheme',
    grpcWeb.MethodType.UNARY,
    stories_v1_story_pb.CreateMonthlyThemeRequest,
    stories_v1_story_pb.MonthlyTheme,
    (request: stories_v1_story_pb.CreateMonthlyThemeRequest) => {
      return request.serializeBinary();
    },
    stories_v1_story_pb.MonthlyTheme.deserializeBinary
  );

  createMonthlyTheme(
    request: stories_v1_story_pb.CreateMonthlyThemeRequest,
    metadata?: grpcWeb.Metadata | null): Promise<stories_v1_story_pb.MonthlyTheme>;

  createMonthlyTheme(
    request: stories_v1_story_pb.CreateMonthlyThemeRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: stories_v1_story_pb.MonthlyTheme) => void): grpcWeb.ClientReadableStream<stories_v1_story_pb.MonthlyTheme>;

  createMonthlyTheme(
    request: stories_v1_story_pb.CreateMonthlyThemeRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: stories_v1_story_pb.MonthlyTheme) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/stories.v1.StoryService/CreateMonthlyTheme',
        request,
        metadata || {},
        this.methodDescriptorCreateMonthlyTheme,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/stories.v1.StoryService/CreateMonthlyTheme',
    request,
    metadata || {},
    this.methodDescriptorCreateMonthlyTheme);
  }

  methodDescriptorUpdateMonthlyTheme = new grpcWeb.MethodDescriptor(
    '/stories.v1.StoryService/UpdateMonthlyTheme',
    grpcWeb.MethodType.UNARY,
    stories_v1_story_pb.UpdateMonthlyThemeRequest,
    stories_v1_story_pb.MonthlyTheme,
    (request: stories_v1_story_pb.UpdateMonthlyThemeRequest) => {
      return request.serializeBinary();
    },
    stories_v1_story_pb.MonthlyTheme.deserializeBinary
  );

  updateMonthlyTheme(
    request: stories_v1_story_pb.UpdateMonthlyThemeRequest,
    metadata?: grpcWeb.Metadata | null): Promise<stories_v1_story_pb.MonthlyTheme>;

  updateMonthlyTheme(
    request: stories_v1_story_pb.UpdateMonthlyThemeRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: stories_v1_story_pb.MonthlyTheme) => void): grpcWeb.ClientReadableStream<stories_v1_story_pb.MonthlyTheme>;

  updateMonthlyTheme(
    request: stories_v1_story_pb.UpdateMonthlyThemeRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: stories_v1_story_pb.MonthlyTheme) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/stories.v1.StoryService/UpdateMonthlyTheme',
        request,
        metadata || {},
        this.methodDescriptorUpdateMonthlyTheme,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/stories.v1.StoryService/UpdateMonthlyTheme',
    request,
    metadata || {},
    this.methodDescriptorUpdateMonthlyTheme);
  }

  methodDescriptorListTags = new grpcWeb.MethodDescriptor(
    '/stories.v1.StoryService/ListTags',
    grpcWeb.MethodType.UNARY,
    stories_v1_story_pb.ListTagsRequest,
    stories_v1_story_pb.ListTagsResponse,
    (request: stories_v1_story_pb.ListTagsRequest) => {
      return request.serializeBinary();
    },
    stories_v1_story_pb.ListTagsResponse.deserializeBinary
  );

  listTags(
    request: stories_v1_story_pb.ListTagsRequest,
    metadata?: grpcWeb.Metadata | null): Promise<stories_v1_story_pb.ListTagsResponse>;

  listTags(
    request: stories_v1_story_pb.ListTagsRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: stories_v1_story_pb.ListTagsResponse) => void): grpcWeb.ClientReadableStream<stories_v1_story_pb.ListTagsResponse>;

  listTags(
    request: stories_v1_story_pb.ListTagsRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: stories_v1_story_pb.ListTagsResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/stories.v1.StoryService/ListTags',
        request,
        metadata || {},
        this.methodDescriptorListTags,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/stories.v1.StoryService/ListTags',
    request,
    metadata || {},
    this.methodDescriptorListTags);
  }

  methodDescriptorGetHome = new grpcWeb.MethodDescriptor(
    '/stories.v1.StoryService/GetHome',
    grpcWeb.MethodType.UNARY,
    stories_v1_story_pb.GetHomeRequest,
    stories_v1_story_pb.GetHomeResponse,
    (request: stories_v1_story_pb.GetHomeRequest) => {
      return request.serializeBinary();
    },
    stories_v1_story_pb.GetHomeResponse.deserializeBinary
  );

  getHome(
    request: stories_v1_story_pb.GetHomeRequest,
    metadata?: grpcWeb.Metadata | null): Promise<stories_v1_story_pb.GetHomeResponse>;

  getHome(
    request: stories_v1_story_pb.GetHomeRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: stories_v1_story_pb.GetHomeResponse) => void): grpcWeb.ClientReadableStream<stories_v1_story_pb.GetHomeResponse>;

  getHome(
    request: stories_v1_story_pb.GetHomeRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: stories_v1_story_pb.GetHomeResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/stories.v1.StoryService/GetHome',
        request,
        metadata || {},
        this.methodDescriptorGetHome,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/stories.v1.StoryService/GetHome',
    request,
    metadata || {},
    this.methodDescriptorGetHome);
  }

  methodDescriptorCreateStory = new grpcWeb.MethodDescriptor(
    '/stories.v1.StoryService/CreateStory',
    grpcWeb.MethodType.UNARY,
    stories_v1_story_pb.CreateStoryRequest,
    stories_v1_story_pb.Story,
    (request: stories_v1_story_pb.CreateStoryRequest) => {
      return request.serializeBinary();
    },
    stories_v1_story_pb.Story.deserializeBinary
  );

  createStory(
    request: stories_v1_story_pb.CreateStoryRequest,
    metadata?: grpcWeb.Metadata | null): Promise<stories_v1_story_pb.Story>;

  createStory(
    request: stories_v1_story_pb.CreateStoryRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: stories_v1_story_pb.Story) => void): grpcWeb.ClientReadableStream<stories_v1_story_pb.Story>;

  createStory(
    request: stories_v1_story_pb.CreateStoryRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: stories_v1_story_pb.Story) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/stories.v1.StoryService/CreateStory',
        request,
        metadata || {},
        this.methodDescriptorCreateStory,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/stories.v1.StoryService/CreateStory',
    request,
    metadata || {},
    this.methodDescriptorCreateStory);
  }

  methodDescriptorUpdateStory = new grpcWeb.MethodDescriptor(
    '/stories.v1.StoryService/UpdateStory',
    grpcWeb.MethodType.UNARY,
    stories_v1_story_pb.UpdateStoryRequest,
    stories_v1_story_pb.Story,
    (request: stories_v1_story_pb.UpdateStoryRequest) => {
      return request.serializeBinary();
    },
    stories_v1_story_pb.Story.deserializeBinary
  );

  updateStory(
    request: stories_v1_story_pb.UpdateStoryRequest,
    metadata?: grpcWeb.Metadata | null): Promise<stories_v1_story_pb.Story>;

  updateStory(
    request: stories_v1_story_pb.UpdateStoryRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: stories_v1_story_pb.Story) => void): grpcWeb.ClientReadableStream<stories_v1_story_pb.Story>;

  updateStory(
    request: stories_v1_story_pb.UpdateStoryRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: stories_v1_story_pb.Story) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/stories.v1.StoryService/UpdateStory',
        request,
        metadata || {},
        this.methodDescriptorUpdateStory,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/stories.v1.StoryService/UpdateStory',
    request,
    metadata || {},
    this.methodDescriptorUpdateStory);
  }

  methodDescriptorDeleteStory = new grpcWeb.MethodDescriptor(
    '/stories.v1.StoryService/DeleteStory',
    grpcWeb.MethodType.UNARY,
    stories_v1_story_pb.DeleteStoryRequest,
    google_protobuf_empty_pb.Empty,
    (request: stories_v1_story_pb.DeleteStoryRequest) => {
      return request.serializeBinary();
    },
    google_protobuf_empty_pb.Empty.deserializeBinary
  );

  deleteStory(
    request: stories_v1_story_pb.DeleteStoryRequest,
    metadata?: grpcWeb.Metadata | null): Promise<google_protobuf_empty_pb.Empty>;

  deleteStory(
    request: stories_v1_story_pb.DeleteStoryRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: google_protobuf_empty_pb.Empty) => void): grpcWeb.ClientReadableStream<google_protobuf_empty_pb.Empty>;

  deleteStory(
    request: stories_v1_story_pb.DeleteStoryRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: google_protobuf_empty_pb.Empty) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/stories.v1.StoryService/DeleteStory',
        request,
        metadata || {},
        this.methodDescriptorDeleteStory,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/stories.v1.StoryService/DeleteStory',
    request,
    metadata || {},
    this.methodDescriptorDeleteStory);
  }

  methodDescriptorListComments = new grpcWeb.MethodDescriptor(
    '/stories.v1.StoryService/ListComments',
    grpcWeb.MethodType.UNARY,
    stories_v1_story_pb.ListCommentsRequest,
    stories_v1_story_pb.ListCommentsResponse,
    (request: stories_v1_story_pb.ListCommentsRequest) => {
      return request.serializeBinary();
    },
    stories_v1_story_pb.ListCommentsResponse.deserializeBinary
  );

  listComments(
    request: stories_v1_story_pb.ListCommentsRequest,
    metadata?: grpcWeb.Metadata | null): Promise<stories_v1_story_pb.ListCommentsResponse>;

  listComments(
    request: stories_v1_story_pb.ListCommentsRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: stories_v1_story_pb.ListCommentsResponse) => void): grpcWeb.ClientReadableStream<stories_v1_story_pb.ListCommentsResponse>;

  listComments(
    request: stories_v1_story_pb.ListCommentsRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: stories_v1_story_pb.ListCommentsResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/stories.v1.StoryService/ListComments',
        request,
        metadata || {},
        this.methodDescriptorListComments,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/stories.v1.StoryService/ListComments',
    request,
    metadata || {},
    this.methodDescriptorListComments);
  }

  methodDescriptorCreateComment = new grpcWeb.MethodDescriptor(
    '/stories.v1.StoryService/CreateComment',
    grpcWeb.MethodType.UNARY,
    stories_v1_story_pb.CreateCommentRequest,
    stories_v1_story_pb.Comment,
    (request: stories_v1_story_pb.CreateCommentRequest) => {
      return request.serializeBinary();
    },
    stories_v1_story_pb.Comment.deserializeBinary
  );

  createComment(
    request: stories_v1_story_pb.CreateCommentRequest,
    metadata?: grpcWeb.Metadata | null): Promise<stories_v1_story_pb.Comment>;

  createComment(
    request: stories_v1_story_pb.CreateCommentRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: stories_v1_story_pb.Comment) => void): grpcWeb.ClientReadableStream<stories_v1_story_pb.Comment>;

  createComment(
    request: stories_v1_story_pb.CreateCommentRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: stories_v1_story_pb.Comment) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/stories.v1.StoryService/CreateComment',
        request,
        metadata || {},
        this.methodDescriptorCreateComment,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/stories.v1.StoryService/CreateComment',
    request,
    metadata || {},
    this.methodDescriptorCreateComment);
  }

  methodDescriptorDeleteComment = new grpcWeb.MethodDescriptor(
    '/stories.v1.StoryService/DeleteComment',
    grpcWeb.MethodType.UNARY,
    stories_v1_story_pb.DeleteCommentRequest,
    google_protobuf_empty_pb.Empty,
    (request: stories_v1_story_pb.DeleteCommentRequest) => {
      return request.serializeBinary();
    },
    google_protobuf_empty_pb.Empty.deserializeBinary
  );

  deleteComment(
    request: stories_v1_story_pb.DeleteCommentRequest,
    metadata?: grpcWeb.Metadata | null): Promise<google_protobuf_empty_pb.Empty>;

  deleteComment(
    request: stories_v1_story_pb.DeleteCommentRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: google_protobuf_empty_pb.Empty) => void): grpcWeb.ClientReadableStream<google_protobuf_empty_pb.Empty>;

  deleteComment(
    request: stories_v1_story_pb.DeleteCommentRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: google_protobuf_empty_pb.Empty) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/stories.v1.StoryService/DeleteComment',
        request,
        metadata || {},
        this.methodDescriptorDeleteComment,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/stories.v1.StoryService/DeleteComment',
    request,
    metadata || {},
    this.methodDescriptorDeleteComment);
  }

  methodDescriptorHideComment = new grpcWeb.MethodDescriptor(
    '/stories.v1.StoryService/HideComment',
    grpcWeb.MethodType.UNARY,
    stories_v1_story_pb.HideCommentRequest,
    stories_v1_story_pb.Comment,
    (request: stories_v1_story_pb.HideCommentRequest) => {
      return request.serializeBinary();
    },
    stories_v1_story_pb.Comment.deserializeBinary
  );

  hideComment(
    request: stories_v1_story_pb.HideCommentRequest,
    metadata?: grpcWeb.Metadata | null): Promise<stories_v1_story_pb.Comment>;

  hideComment(
    request: stories_v1_story_pb.HideCommentRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: stories_v1_story_pb.Comment) => void): grpcWeb.ClientReadableStream<stories_v1_story_pb.Comment>;

  hideComment(
    request: stories_v1_story_pb.HideCommentRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: stories_v1_story_pb.Comment) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/stories.v1.StoryService/HideComment',
        request,
        metadata || {},
        this.methodDescriptorHideComment,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/stories.v1.StoryService/HideComment',
    request,
    metadata || {},
    this.methodDescriptorHideComment);
  }

  methodDescriptorReplyToComment = new grpcWeb.MethodDescriptor(
    '/stories.v1.StoryService/ReplyToComment',
    grpcWeb.MethodType.UNARY,
    stories_v1_story_pb.ReplyToCommentRequest,
    stories_v1_story_pb.Comment,
    (request: stories_v1_story_pb.ReplyToCommentRequest) => {
      return request.serializeBinary();
    },
    stories_v1_story_pb.Comment.deserializeBinary
  );

  replyToComment(
    request: stories_v1_story_pb.ReplyToCommentRequest,
    metadata?: grpcWeb.Metadata | null): Promise<stories_v1_story_pb.Comment>;

  replyToComment(
    request: stories_v1_story_pb.ReplyToCommentRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: stories_v1_story_pb.Comment) => void): grpcWeb.ClientReadableStream<stories_v1_story_pb.Comment>;

  replyToComment(
    request: stories_v1_story_pb.ReplyToCommentRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: stories_v1_story_pb.Comment) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/stories.v1.StoryService/ReplyToComment',
        request,
        metadata || {},
        this.methodDescriptorReplyToComment,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/stories.v1.StoryService/ReplyToComment',
    request,
    metadata || {},
    this.methodDescriptorReplyToComment);
  }

}

